import styled from 'styled-components';
import { HqOCalendar } from '@hqo/react-components-library/dist/molecules/hqo-date-picker';
import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';
import { brandedDayCellStyles } from 'components/calendar-styles/branded-day-cell.styles';

export const Container = styled.div`
  width: 370px;
  display: flex;
  align-items: center;
  flex-direction: column;
  scroll-margin-top: -50px;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    width: 100%;
  }
`;

export const StyledCalendar = styled(HqOCalendar)`
  .days-view {
    border: none;
  }

  .day-cell {
    border: none;
    border-radius: 50%;
  }

  .button-view {
    margin-top: 0;
  }

  ${brandedDayCellStyles}
`;
